import { Extension } from "@tiptap/core";
import VariableInsertButton from "./components/VariableInsertButton";
import { ensureNameValueOptions } from "../../utils/utils";

export const InsertVariable = Extension.create({
	name: "insertVariable",

	addOptions() {
		return {
			variablesList: [],
			button({ editor, extension, t }) {
				const variablesList = ensureNameValueOptions(
					extension?.options?.variablesList || []
				);

				const processVariables = (variables) => {
					return variables.map((variable) => {
						const item = {
							action: () => {
								if (variable.value === '${qrcode}') {
									editor.chain().focus().insertContent('<div style="text-align: center;" class="image"><img height="auto" src="https://files.konfhub.com/sample_qrcode.png" width="200"></div>').run();
									return
								}
								editor.chain().focus().insertContent(variable.value).run()
							},
							isActive: () => false,
							disabled: false,
							name: variable.name,
							value: variable.value,
							children: variable.children
								? processVariables(variable.children)
								: null
						};
						return item;
					});
				};

				const items = processVariables(variablesList);
				const disabled = items.every((item) => item.disabled);

				return {
					component: VariableInsertButton,
					componentProps: {
						tooltip: t("editor.variableInsert.default.tooltip"),
						disabled,
						items,
						editor
					}
				};
			}
		};
	},

	addCommands() {
		return {
			insertVariable:
				(variable) =>
					({ commands }) => {
						const formattedVariable = variable;
						return commands.insertContent(formattedVariable);
					}
		};
	}
});
